import router from './router'
import NProgress from 'nprogress' // Progress 进度条
import { getToken } from '@utils/auth' // 验权
import store from '@store'

const whiteList = ['/login', '/404', 'therapy'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    store.dispatch('_GetInfo')
    if (to.path === '/login') {
      // 如果当前处于登录状态，并且跳转地址为 login 时，自动返回系统首页
      next({ path: '/' })
      NProgress.done()
    } else if (to.path === '/404') {
      next()
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // next()
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
